import Vue from 'vue'
import firebase from "firebase";

const state = {
  user: false,
  admins: [],
  appointments: [], 
  clients: [],
  contactEvents: [],
  contracts: [],
  instructions: [], 
  locations: [], 
  messages: [],
  organisations: [], 
  panelists: [], 
  posts: [],
  projectAvailability: [],
  projects: [],
  projectSlots: [],
  requests: [],
  savedQuestions: [], 
  surveys: [], 
  surveyResponses: [], 
  tags: [],
  tasks: [],
  visitors: [],
  videoCompositions: []
}

const actions = {
  bindAnything({ commit, state }, {id, collection, then, reference} ) {
    if( !id ){
      return;
    }
    let exists = state[reference].find( a => a.id == id );
    if( !exists ){    
      firebase.firestore().collection(collection).doc(id).onSnapshot(snapshot => {
        if( snapshot.exists ){
            let data = snapshot.data();
            data.bound = true;
            commit(then, { id: snapshot.id, data: data, reference: reference });
        }        
      });
      return true;
    }
    return false;
  },
  fetchUser({ state}){
    firebase.firestore().doc("users/"+ firebase.auth().currentUser.uid ).onSnapshot( snapshot => {
      if( snapshot.exists ){
        let data = snapshot.data();
        data.id = snapshot.id;       
        Vue.set( state, "user", data );
      } 
    })
  },
  fetchVideoCompositions({dispatch}, appointmentId ){
    firebase.firestore().collection("videoCompositions")
      .where("appointment", "==", appointmentId)
      .onSnapshot( snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "videoCompositions", then: "SET_ANYTHING", reference: "videoCompositions"} )
        })
      })
  },  
  fetchSurveyResponses({dispatch}, id ){
    firebase.firestore().collection("surveyResponses")
      .where("survey", "==", id)
      .get()
      .then( snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "surveyResponses", then: "SET_ANYTHING", reference: "surveyResponses"} )
          if( doc.data().type == 'visitor' ){
            dispatch("bindAnything", {id: doc.data().respondent, collection: "visitors", then: "SET_ANYTHING", reference: "visitors"} )
          }
          else{
            dispatch("bindAnything", {id: doc.data().respondent, collection: "users", then: "SET_ANYTHING", reference: "panelists"} )
          }
        })
      })
  },  
  fetchSurvey({dispatch}, id ){
    dispatch("bindAnything", {id: id, collection: "surveys", then: "SET_ANYTHING", reference: "surveys" } )
  },
  fetchPost({dispatch}, id ){
    dispatch("bindAnything", {id: id, collection: "posts", then: "SET_ANYTHING", reference: "posts" } )
  },
  fetchRequests({dispatch}, id ){
    firebase.firestore().collection("requests")
      .where("organisation", "==", id)
      .onSnapshot(snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "requests", then: "SET_ANYTHING", reference: "requests"} )
        })
      })
  },
  fetchSurveyQuestionLibrary({commit} ){
    firebase.firestore().collection("surveyQuestionLibrary").onSnapshot(snapshot => {
      snapshot.forEach( ( doc ) => {
        let data = doc.data();
        data.bound = true;
        commit("SET_ANYTHING", { id: doc.id, data: data, reference: "savedQuestions" });
      } )   
    });
  },
  bindTags({ commit}){
    firebase.firestore().collection("tags").onSnapshot(snapshot => {
      snapshot.forEach( ( doc ) => {
        let data = doc.data();
        data.bound = true;
        commit("SET_ANYTHING", { id: doc.id, data: data, reference: "tags" });
      } )
           
    });
  },
  fetchProjectSlots({dispatch}, id ){
    dispatch("bindAnything", {id: id, collection: "projectSlots", then: "SET_ANYTHING", reference: "projectSlots" } )
  },  
  fetchContracts({dispatch}, id ){
    firebase.firestore().collection("contracts")
      .where("organisation", "==", id)
      .onSnapshot(snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "contracts", then: "SET_ANYTHING", reference: "contracts"} )
        })
      })
  },
  fetchOrganisation({dispatch, commit }, id ){
      firebase.firestore().collection("organisations").doc(id).onSnapshot(doc => {
        let organisation = doc.data();
        organisation.bound = true;
        commit("SET_ANYTHING", { id: id, data: organisation, reference: "organisations" });
        dispatch("fetchContracts", organisation.id )
        dispatch("fetchRequests", organisation.id)
        firebase.firestore().collection("users")
          .where("role", "==", "client")
          .where("organisation", "==", organisation.id)
            .onSnapshot(snapshot => {
              snapshot.forEach( user => {
                dispatch("bindAnything", {id: user.id, collection: "users", then: "SET_ANYTHING", reference: "clients"} )
              })
            })
      });
  },
  fetchRequest({dispatch,  commit }, id ){
    firebase.firestore().collection("requests").doc(id).onSnapshot(doc => {
      let request = doc.data();
      request.bound = true;
      commit("SET_ANYTHING", { id: id, data: request, reference: "requests" });
      if( request.organisation ){
        dispatch("bindAnything", {id: request.organisation, collection: "organisations", then: "SET_ANYTHING", reference: "organisations"} )
      }
      if( request.contract ){
        dispatch("bindAnything", {id: request.contract, collection: "contracts", then: "SET_ANYTHING", reference: "contracts"} )
      }
      Object.keys(request.users).filter( u => request.users[u] == 'client' ).forEach( c => {
        dispatch("bindAnything", {id: c, collection: "users", then: "SET_ANYTHING", reference: "clients"} )
      })
    });
  },
  fetchAppointment({dispatch}, id ){
    firebase.firestore().doc("appointments/" + id ).get().then( doc => {
      dispatch("bindAnything", {id: doc.id, collection: "appointments", then: "SET_ANYTHING", reference: "appointments"} )
      let appointment = doc.data();
      if( appointment.participant ){
        dispatch("bindAnything", {id: appointment.participant, collection: "users", then: "SET_ANYTHING", reference: "panelists"} )
      }
    })
  },  
  fetchProjectAppointments({dispatch}, id ){
    firebase.firestore().collection("appointments")
      .where("publishStatus", "==", "live")
      .where("project", "==", id)
      .get()
      .then( snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "appointments", then: "SET_ANYTHING", reference: "appointments"} )
          let appointment = doc.data();
          if( appointment.participant ){
            dispatch("bindAnything", {id: appointment.participant, collection: "users", then: "SET_ANYTHING", reference: "panelists"} )
          }
        })
      })
  },  
  bindProject({dispatch, state, commit }, id ){
    let exists = state.projects.filter( p => p.bound == true).find( p => p.id == id );
    if( !exists ){    
      firebase.firestore().collection("projects").doc(id).onSnapshot(doc => {
        let project = doc.data();
        project.bound = true;
        commit("SET_ANYTHING", { id: id, data: project, reference: "projects" });
        dispatch("bindAnything", {id: id, collection: "projectAvailability", then: "SET_ANYTHING", reference: "projectAvailability"} )
        dispatch("fetchProjectAppointments", id )
        if( project.client ) {
          dispatch("bindAnything", {id: project.client, collection: "organisations", then: "SET_ANYTHING", reference: "organisations"} )
        }
        if( project.instruction ) {
          dispatch("bindAnything", {id: project.instruction, collection: "instructions", then: "SET_ANYTHING", reference: "instructions"} )
        }
        if( project.location ) {
          dispatch("bindAnything", {id: project.location, collection: "locations", then: "SET_ANYTHING", reference: "locations"} )
        }
        if( project.screener ) {
          dispatch("bindAnything", {id: project.screener, collection: "surveys", then: "SET_ANYTHING", reference: "surveys"} )
        }
        let admins = Object.keys( project.users ).filter( key => project.users[key] == 'admin' );
        admins.forEach( u => {
          dispatch("bindAnything", {id: u, collection: "users", then: "SET_ANYTHING", reference: "admins"} )
        })
        let clients = Object.keys( project.users ).filter( key => project.users[key] == 'client' );
        clients.forEach( u => {
          dispatch("bindAnything", {id: u, collection: "users", then: "SET_ANYTHING", reference: "clients"} )
        })
      });
    }    
  },
  fetchUserProjects( {dispatch}, {userId, role } ){
    firebase.firestore().collection("projects")
      .where("publishStatus", "==", "live")
      .where("users."+userId, "==", role)
      .get()
      .then( snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindProject", doc.id);
        })
      })
  },
  fetchOrganisationProjects( {dispatch}, id ){
    firebase.firestore().collection("projects")
      .where("publishStatus", "==", "live")
      .where("client", "==", id)
      .get()
      .then( snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindProject", doc.id);
        })
      })
  },
  fetchInboundMessages( {commit, dispatch}, options ){    
    let query = firebase.firestore().collection("contactEvents")
    if( options.project ){ 
      query = query.where("project", "==", options.project )
    }
    query = query.where("direction", "==", "inbound").orderBy( "created", "desc" )
    query.get().then( snapshot => {
      snapshot.forEach( function(doc){
        if( doc.data().recipient ){
          dispatch("bindAnything", {id: doc.data().recipient, collection: "users", then: "SET_ANYTHING", reference: "panelists"} )
        }
        commit("SET_ANYTHING", { id: doc.id, data: doc.data(), reference: "contactEvents" });
      }) 
    })   
  },
  fetch( {commit}, reference, ){
    var role;
    switch (reference){
      case "panelists": 
        reference = "panelists"
        firebase.firestore().collection("users")
          .where("publishStatus", "==", "live" )
          .where("role", "in", ["panelmember", "panelcandidate" ] )
          .onSnapshot(snapshot => {
            snapshot.forEach(doc => {
              let o = doc.data();
              o.bound = true;
              commit("SET_ANYTHING", { id: doc.id, data: o, reference: reference });
            });
          }) 
        break;
      case "panelmembers": 
      case "panelcandidates":
        role = reference.substr(0, reference.length - 1)
        reference = "panelists"
        firebase.firestore().collection("users")
          .where("publishStatus", "==", "live" )
          .where("role", "==", role )
          .onSnapshot(snapshot => {
            snapshot.forEach(doc => {
              let o = doc.data();
              o.bound = true;
              commit("SET_ANYTHING", { id: doc.id, data: o, reference: reference });
            });
          }) 
      break;
      case "admins":
      case "clients":
        role = reference.substr(0, reference.length - 1)
        firebase.firestore().collection("users")
          .where("publishStatus", "==", "live" )
          .where("role", "==", role )
          .onSnapshot(snapshot => {
            snapshot.forEach(doc => {
              let o = doc.data();
              o.bound = true;
              commit("SET_ANYTHING", { id: doc.id, data: o, reference: reference });
            });
          })  
      break;
      default: 
        firebase.firestore().collection(reference)
          .orderBy("updated", "desc")
          .onSnapshot(snapshot => {
            snapshot.forEach(doc => {
              let o = doc.data();
              o.bound = true;
              commit("SET_ANYTHING", { id: doc.id, data: o, reference: reference });
            });
          })
      
    }
  },
  fetchMyProjects({ dispatch } ) {
    firebase.firestore().collection("projects")
      .where("publishStatus", "==", "live" )
      .where("active", "==", true )
      .where("status", "==", "open" )
      .where("users."+firebase.auth().currentUser.uid, "==", "admin")
      .limit(10)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          dispatch("bindProject", doc.id )      
        });
    })
  },
  fetchNamedUrl( {state}, { objectId, type } ){
      state;
      return new Promise( (resolve, reject) => {
        firebase.firestore().collection("namedUrls").where("objectId", "==", objectId ).where("type", "==", type ).get().then( snapshot => {
          snapshot.forEach( function(url){
            if( url.exists ){
              resolve( url.id )
            }
            else{
              reject(false)
            }
          })
        })     
      } ) 
  },
  querypanelists({state}, conditions ){
    state;
    let query = firebase.firestore().collection("surveyResponses")
    conditions.forEach( condition => {
      if( condition ){ 
        query = query.where("data." + condition.question, condition.operator, condition.value )
      }
    })
    return new Promise( (resolve) => {
      query.get().then( snapshot => {
        let results = [];
        snapshot.forEach( function(response){ 
          results.push( response.data().respondent )
        }) 
        resolve( results )
      })   
    })
  },
  delete( {commit}, {id, collection}){
    commit("DELETE_SOMETHING", {id, collection} )
  },
};
const mutations = {
  SET_ANYTHING(state, {id, data, reference}) {
    if( !id ){ return; }
    if( typeof data == 'undefined') { return; }
    if( !state[reference] ) { return; }
    let index = state[reference].length;
    data.id = id;
    let exists = state[reference].find( p => p.id == id );
    if( exists ){
      index = state[reference].indexOf( exists )
    }
    Vue.set( state[reference], index, data );
  },
  DELETE_SOMETHING(state, {id, collection}){
    var found = state[collection].find(item => item.id == id)
    state[collection].splice( state[collection].indexOf(found), 1)
  }

};


export default {
  state, 
  actions, 
  mutations
};
